<template>
  <Grid class="content-jobslist">
    <template v-if="data.list" v-for="job in data.list">
      <NuxtLink v-if="job.slug" class="item" :to="getJobRoute(job.slug)">
        <div class="content">
          <h2 class="title text-md">{{ job.title }}</h2>
          <span class="subline text-xs">{{ job.area }}</span>
        </div>
        <Icon type="arrow-corner-right" />
      </NuxtLink>
    </template>
  </Grid>
</template>

<script setup lang="ts">
// Imports
import Icon from '~/components/elements/Icon.vue';
import Grid from '~/components/partials/Grid.vue';

// Types
import type { ContentJobslistFragment } from '#gql';

// Props
const props = defineProps<{
  data: ContentJobslistFragment;
}>();

// Composables
const i18n = useI18n();

// Methods
const getJobRoute = (slug: string) => {
  return `/${i18n.localeProperties.value.siteLocale}/jobs/${slug}`;
};
</script>

<style lang="scss" scoped>
.content-jobslist {
  row-gap: 2.5rem;
}
.content-jobslist > .item {
  background-color: hsla(0, 0%, 100%, 0.8);
  border-radius: 0.5rem;
  text-decoration: none;
  display: flex;

  &:hover {
    color: var(--base-color-foreground);
  }

  @media (--vs) {
    padding: 1rem;
    flex-direction: column-reverse;
    align-items: flex-end;
    gap: 0.5rem;
  }

  @media (--vl) {
    padding: 2.5rem;
    gap: 2.5rem;
    grid-column: 2/7;
  }
}
.content-jobslist > .item > .content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}
</style>
